<template>
    <svg :cssClass="cssClass" :class="iconCssClass" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.7451 6.33322C18.7407 6.18688 18.6824 6.0441 18.5746 5.93634L12.8097 0.171436C12.8095 0.171192 12.8093 0.171094 12.8091 0.17085C12.7031 0.0652833 12.5571 0 12.3959 0H1.23233C0.552784 0 0 0.552735 0 1.23228V23.7677C0 24.4472 0.552735 25 1.23228 25H17.5138C18.1932 25 18.746 24.4473 18.746 23.7677V6.35021C18.7461 6.34445 18.7454 6.33888 18.7451 6.33322ZM12.9812 1.99859L16.7476 5.76495H13.2282C13.092 5.76495 12.9812 5.65416 12.9812 5.51793V1.99859ZM17.5754 23.7678C17.5754 23.8017 17.5477 23.8293 17.5138 23.8293H1.23233C1.19839 23.8293 1.17075 23.8017 1.17075 23.7678V1.23228C1.17075 1.19834 1.19839 1.17071 1.23233 1.17071H11.8105V5.51793C11.8105 6.29962 12.4465 6.93566 13.2282 6.93566H17.5755V23.7678H17.5754Z" fill="#3577D3"/>
    </svg>
</template>

<script>
export default {

	props: {
		cssClass: {
			type: String,
			default: () => '',
		},
    },

    computed: {

        iconCssClass()
        {
            return `icon-svg ${this.cssClass} icon-svg--document`
        },

    },

}
</script>

<style lang="scss">
a {
    .icon-svg--document {
        width: 18.75px;
        height: 25px;
    }
}
</style>
